module.exports = __webpack_public_path__ + "static/Dany-37870a11364d8a31e010e3459ca26545.png";